import { z } from 'zod';

export const customerSchema = z.object({
	name: z.string().min(1, 'Name is required'),
	photoUrl: z.string().optional().nullable(),
	phone: z
		.string()
		.max(20, 'Phone number is required')
		.optional()
		.nullable()
		.or(z.literal('')),
	email: z
		.string()
		.optional()
		.nullable()
		.or(z.literal(''))
		.or(z.string().email().max(100, 'Invalid email address')),
	details: z
		.string()
		.optional()
		.nullable()
		.or(z.literal(''))
		.or(z.string().max(2000, 'Details name too long')),
	_properties: z
		.union([
			z.array(
				z.object({
					mainText: z.string().optional().or(z.literal('')),
					secondaryText: z.string().optional().or(z.literal('')),
				})
			),
			z.array(z.string()),
		])
		.optional(),
	billingEmail: z
		.string()
		.optional()
		.nullable()
		.or(z.literal(''))
		.or(z.string().email().max(100, 'Invalid email address')),
	billingAddress: z
		.string()
		.optional()
		.nullable()
		.or(z.literal(''))
		.or(z.string().max(2000, 'Address too long')),
	tags: z.array(z.string()).optional().nullable().or(z.literal('')),
	associatedLinks: z
		.array(
			z.object({
				name: z.string().max(1000, 'Name too long'),
				url: z.string().max(1000, 'URL too long'),
			})
		)
		.optional()
		.nullable(),
	_id: z.string().optional(),
});

export type CustomerData = z.infer<typeof customerSchema>;
